import { MenuItem, Select } from '@mui/material';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import * as React from 'react';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import { useTranslation } from '../../contexts/TranslationContext';
import useApi from '../../api';
import { useResponseHandler } from '../../utils/response';
import { PublicLocaleObj } from '../../api/types';

type PageLocaleSelectProps = {
    selectedLocale?: string;
    onLocaleChange?: (selectedLocale: string) => void;
    fullWidth?: boolean;
};

export default function PageLocaleSelect({
    selectedLocale,
    onLocaleChange,
    fullWidth,
}: PageLocaleSelectProps) {
    const { getLocales } = useApi();
    const { i18n, translate } = useTranslation();

    const { handleResponse } = useResponseHandler();

    const [locales, setLocales] = useState<Array<PublicLocaleObj>>([]);

    const loadLocales = () => {
        getLocales(false).then(response => {
            handleResponse(response, () => {
                setLocales(response ?? []);
            });
        });
    };

    useEffect(loadLocales, [getLocales]);

    const onChange = (event: SelectChangeEvent, child: ReactNode) => {
        if (child) {
            // @ts-ignore
            const props: FilePoolSelectItem = child.props;
            if (props) {
                onLocaleChange && onLocaleChange(props['data-locale']);
            }
        }
    };

    const renderLocaleSelectItem = (locale: PublicLocaleObj) => {
        return (
            <MenuItem
                key={locale.locale}
                value={locale.locale}
                data-locale={locale.locale}
                selected={selectedLocale === locale.locale}>
                {translate(locale.title)}
            </MenuItem>
        );
    };

    return useMemo(() => {
        return (
            <Select
                value={selectedLocale ?? i18n}
                onChange={onChange}
                fullWidth={fullWidth}>
                {locales.map(renderLocaleSelectItem)}
            </Select>
        );
    }, [locales, selectedLocale, i18n, fullWidth]);
}
